"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
class NetworkFirstCompositeCacheStrategy {
    constructor(cache) {
        this.cacheOnly = false;
        this.get = async (keys, getRequest, denormalize, normalize) => {
            if (this.cacheOnly) {
                return normalize(await this.fromCache(keys));
            }
            try {
                const value = await getRequest(null);
                for (const [key, val] of denormalize(value).entries()) {
                    await this.cache.setObject(key, val);
                }
                return value;
            }
            catch (e) {
                if (e instanceof exception_1.NetworkException) {
                    return normalize(await this.fromCache(keys));
                }
                throw e;
            }
        };
        this.cache = cache;
    }
    goCacheOnly() {
        this.cacheOnly = true;
    }
    goRegular() {
        this.cacheOnly = false;
    }
    async fromCache(keys) {
        const promises = new Map();
        keys.forEach((key) => {
            promises.set(key, this.cache
                .getObject(key)
                .withDefault(null)
                .asPromise());
        });
        const values = await Promise.all(promises.values());
        const res = new Map();
        for (let i = 0; i < values.length; i++) {
            res.set(keys[i], values[i]);
        }
        return res;
    }
}
exports.default = NetworkFirstCompositeCacheStrategy;
//# sourceMappingURL=NetworkFirstCompositeStrategy.js.map